<script>
  /* global agGrid */
  import GRID_LOCALE_CS from '../js/gridLocaleCs.js';
  import GRID_LOCALE_EN from '../js/gridLocaleEn.js';
  import { onMount } from 'svelte';

  export let value;
  export let team;
  export let name;
  export let lang = undefined;
  export let mode = undefined;

  let statisticsFieldingElement;

  let gridOptions;

  function getOptions () {
    return {
      theme: 'legacy',
      defaultColDef: {
        cellDataType: 'number',
        type: 'numericColumn',
        width: 90,
        sortable: true,
        filter: true,
        filterParams: {
          maxNumConditions: 1,
          defaultJoinOperator: 'OR',
          filterOptions: ['equals', 'inRange', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
        },
        floatingFilter: true,
      },
      columnDefs: [
        {
          headerName: lang !== 'en' ? 'Hráč' : 'Player',
          // eslint-disable-next-line no-magic-numbers
          openByDefault: window.innerWidth > 800,
          children: [
            {
              field: 'lastName',
              headerName: lang !== 'en' ? 'Příjmení' : 'Last name',
              width: 135,
              cellDataType: 'text',
              type: [],
              pinned: true,
              cellStyle: { fontWeight: 'bold' },
              filterParams: {
                maxNumConditions: 2,
                filterOptions: ['contains'],
              },
              floatingFilter: false,
            },
            {
              field: 'firstName',
              headerName: lang !== 'en' ? 'Jméno' : 'First name',
              width: 135,
              cellDataType: 'text',
              type: [],
              pinned: true,
              filterParams: {
                maxNumConditions: 2,
                filterOptions: ['contains'],
              },
              floatingFilter: false,
              columnGroupShow: 'open',
            },
            {
              field: 'team',
              headerName: lang !== 'en' ? 'Tým' : 'Team',
              cellDataType: 'text',
              type: [],
              pinned: true,
              filterParams: {
                maxNumConditions: 4,
                filterOptions: ['contains'],
              },
              floatingFilter: false,
              columnGroupShow: 'open',
              cellRenderer: params => {
                return `
                  <div class='team-cell'>
                    <img class='team-cell-flag' src='img/static/flag/${params.data.flag}.svg'/>
                    <div class='team-cell-label'> ${params.value.toUpperCase()} </div>
                  </div>
                `;
              },
            },
          ],
        },
        {
          field: 'po',
          headerName: 'PO',
          headerTooltip: 'Putout',
          cellStyle: { fontWeight: 'bold' },
        },
        {
          field: 'a',
          headerName: 'A',
          headerTooltip: 'Assist',
        },
        {
          field: 'e',
          headerName: 'E',
          headerTooltip: 'Error',
        },
        {
          field: 'dp',
          headerName: 'DP',
          headerTooltip: 'Double play',
        },
        {
          field: 'pb',
          headerName: 'PB',
          headerTooltip: 'Passed ball',
        },
        {
          field: 'sb',
          headerName: 'SB',
          headerTooltip: 'Stolen base',
        },
        {
          field: 'cs',
          headerName: 'CS',
          headerTooltip: 'Caught stealing',
        },
        {
          field: 'g',
          headerName: 'G',
          headerTooltip: 'Games played',
        },
        {
          field: 'fpct',
          headerName: 'FPCT',
          headerTooltip: 'Fielding percentage',
          valueFormatter: params => `${Math.round(params.value)} %`,
        },
        {
          flex: 1,
          filter: false,
          sortable: false,
          suppressMovable: true,
        },
      ],
      animateRows: true,
      accentedSort: true,
      tooltipShowDelay: 500,
      rowData: value,
      localeText: lang !== 'en' ? GRID_LOCALE_CS : GRID_LOCALE_EN,
      isExternalFilterPresent: () => team !== 'all' || name,
      doesExternalFilterPass: node => {
        if (team !== 'all' && node.data.team !== team) return false;

        if (name) {
          return `${node.data.lastName} ${node.data.firstName}`.toLowerCase().replace(/\s+/g, '').includes(name.toLowerCase().replace(/\s+/g, ''));
        }

        return true;
      },
    };
  }

  onMount(() => {
    gridOptions = getOptions();

    gridOptions.api = agGrid.createGrid(statisticsFieldingElement, gridOptions);
  });

  $: if (gridOptions && lang) {
    gridOptions.api.destroy();
    gridOptions = getOptions();

    gridOptions.api = agGrid.createGrid(statisticsFieldingElement, gridOptions);
  }

  $: filterChanged(team, name);

  function filterChanged () {
    if (gridOptions) gridOptions.api.onFilterChanged(team, name);
  }
</script>

<div class='statistics-fielding ag-theme-balham' bind:this={statisticsFieldingElement}
  class:ag-theme-balham-dark={mode !== 'light'}/>

<style>
  .statistics-fielding {
    width: 100%;
    height: 100%;
  }

  :global(.team-cell) {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  :global(.team-cell-flag) {
    height: 16px;
  }

  :global(body.dark .team-cell-flag) {
    filter: brightness(88%);
  }

  :global(.ag-root-wrapper) {
    border-radius: var(--radius-lg);
  }
</style>
